import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
//window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

// npm install object-fit-images
import objectFitImages from 'object-fit-images';
// npm install swiper
import { Swiper, Navigation, Autoplay, EffectFade } from 'swiper';

Swiper.use([Navigation, Autoplay, EffectFade]);

$(document).foundation();


// function to make mailto from span
  $.fn.buildMailTo = function() {
    var $t = this; // freakin scope
    var pre     = $t.data('pre'),
        post    = $t.data('post'),
        subject = $t.data('subject'),
        classes = $t.attr('class'),
        text    = $t.text();

    var href = 'mailto:' + pre + '@' + post;
    if ( subject )
      href = href + '?subject=' + subject;

    if ( !text )
      text = pre + '@' + post;


    $t.replaceWith( '<a href="' + href + '" class="' + classes + '">' + text + '</a>' );
    return this;
  }

  $('.liambtn').each(function() {
    $(this).buildMailTo();
  });

  $('.to-top').on('click', function(){
    $('html, body').animate({ scrollTop: 0 }, 1000 );
  });
